import { render, staticRenderFns } from "./CrewDeleteModal.vue?vue&type=template&id=165dbad0"
import script from "./CrewDeleteModal.vue?vue&type=script&lang=js"
export * from "./CrewDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports